import { render, staticRenderFns } from "./LoginChooser.vue?vue&type=template&id=081861e4&scoped=true&"
import script from "./LoginChooser.vue?vue&type=script&lang=js&"
export * from "./LoginChooser.vue?vue&type=script&lang=js&"
import style0 from "./LoginChooser.vue?vue&type=style&index=0&id=081861e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081861e4",
  null
  
)

export default component.exports